// FRAETERNITY - FLOW ANIMATIONS
document.addEventListener('DOMContentLoaded', function() {
    
    // Registrar ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);
    
    // ===========================================
    // QUITAR LOADER INMEDIATAMENTE
    // ===========================================
    
    const loader = document.querySelector('.fraet-loader');
    if (loader) {
        // Quitar el loader rápidamente
        gsap.to(loader, {
            opacity: 0,
            duration: 0.3,
            onComplete: () => {
                loader.style.display = 'none';
                loader.remove();
            }
        });
    }
    
    // Esperar un momento antes de iniciar las animaciones
    setTimeout(() => {
        initAllAnimations();
    }, 400);
    
    // ===========================================
    // FUNCIÓN PRINCIPAL DE ANIMACIONES
    // ===========================================
    
    function initAllAnimations() {
        
        // ===========================================
        // HERO SECTION - TEXTO ESCALONADO
        // ===========================================
        
        const heroLines = gsap.utils.toArray('.fraet-hero-text .line span');
        
        if (heroLines.length > 0) {
            gsap.set(heroLines, {
                y: 100,
                opacity: 0
            });
            
            // Entrada dramática
            gsap.to(heroLines, {
                y: 0,
                opacity: 1,
                duration: 1.2,
                stagger: 0.1,
                ease: "power4.out"
            });
            
            // Efecto parallax suave
            gsap.to('.fraet-hero-text', {
                yPercent: -30,
                scrollTrigger: {
                    trigger: '.fraet-hero',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 1
                }
            });
        }

        // ===========================================
        // MANIFESTO - FADE IN PROGRESIVO
        // ===========================================
        
        const manifestoBlocks = gsap.utils.toArray('.fraet-manifesto-text .block');
        
        manifestoBlocks.forEach((block, i) => {
            gsap.set(block, {
                opacity: 0,
                y: 50
            });
            
            gsap.to(block, {
                opacity: 1,
                y: 0,
                duration: 1,
                delay: i * 0.2,
                scrollTrigger: {
                    trigger: block,
                    start: 'top 80%',
                    toggleActions: 'play none none reverse'
                }
            });
        });

        // ===========================================
        // DESIGN SECTION - TEXTO CON EFECTO TYPEWRITER EN SCROLL
        // ===========================================
        
        const designTitle = document.querySelector('.fraet-design-title span');
        if (designTitle) {
            const text = designTitle.textContent;
            designTitle.innerHTML = '';
            
            // Crear spans para cada carácter
            text.split('').forEach(char => {
                const span = document.createElement('span');
                span.classList.add('char');
                span.textContent = char === ' ' ? '\u00A0' : char;
                span.style.opacity = '0';
                designTitle.appendChild(span);
            });
            
            // Animar caracteres con scroll
            const chars = designTitle.querySelectorAll('.char');
            
            ScrollTrigger.create({
                trigger: '.fraet-design',
                start: 'top 60%',
                end: 'top 20%',
                scrub: 1,
                onUpdate: self => {
                    const progress = self.progress;
                    const charsToShow = Math.floor(progress * chars.length);
                    
                    chars.forEach((char, i) => {
                        if (i <= charsToShow) {
                            gsap.to(char, {
                                opacity: 1,
                                duration: 0.1
                            });
                        }
                    });
                }
            });
        }
        
        // Items con stagger - TRIGGER MÁS TEMPRANO
        const designItems = gsap.utils.toArray('.fraet-design-item');
        
        ScrollTrigger.create({
            trigger: '.fraet-design-grid',
            start: 'top 85%',
            onEnter: () => {
                gsap.to(designItems, {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    stagger: 0.15,
                    ease: "power3.out"
                });
            }
        });

        // ===========================================
        // MEMORIES SECTION - CONTADOR Y TÍTULO
        // ===========================================
        
        const memoriesLines = gsap.utils.toArray('.fraet-memories-title .line span');
        
        memoriesLines.forEach((line, i) => {
            gsap.from(line, {
                yPercent: 100,
                duration: 1,
                delay: i * 0.1,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: '.fraet-memories-title',
                    start: 'top 80%'
                }
            });
        });
        
        // Stats con contador
        const stats = gsap.utils.toArray('.fraet-stat');
        
        gsap.set(stats, {
            opacity: 0,
            y: 30
        });
        
        ScrollTrigger.create({
            trigger: '.fraet-memories-stats',
            start: 'top 70%',
            onEnter: () => {
                stats.forEach((stat, i) => {
                    const numberEl = stat.querySelector('.fraet-stat-number');
                    const target = parseInt(numberEl.dataset.target);
                    
                    // Fade in
                    gsap.to(stat, {
                        opacity: 1,
                        y: 0,
                        duration: 0.6,
                        delay: i * 0.1,
                        ease: "power2.out"
                    });
                    
                    // Contador
                    const obj = { value: 0 };
                    gsap.to(obj, {
                        value: target,
                        duration: 2,
                        delay: i * 0.1,
                        ease: "power2.out",
                        onUpdate: () => {
                            const val = Math.floor(obj.value);
                            if(target === 100) {
                                numberEl.textContent = val + '%';
                            } else if(target > 1000) {
                                numberEl.textContent = (val / 1000).toFixed(0) + 'K+';
                            } else {
                                numberEl.textContent = val + '+';
                            }
                        }
                    });
                });
            },
            once: true
        });

        // ===========================================
        // COMMUNITY CARDS - SCROLL HORIZONTAL MEJORADO
        // ===========================================
        
        const communityScroll = document.querySelector('.fraet-community-scroll');
        const communityCards = gsap.utils.toArray('.fraet-community-card');
        
        if (communityScroll && communityCards.length > 0) {
            // Calcular el ancho total necesario para el scroll
            let scrollWidth = (communityCards.length * 430) + 200;
            
            // Crear scroll horizontal más largo
            gsap.to(communityScroll, {
                x: () => -(scrollWidth - window.innerWidth + 100),
                ease: "none",
                scrollTrigger: {
                    trigger: '.fraet-community',
                    start: 'top top',
                    end: () => `+=${scrollWidth * 1.5}`,
                    scrub: 0.5,
                    pin: true,
                    anticipatePin: 1
                }
            });
            
            // Fade in de las cards
            communityCards.forEach((card, i) => {
                gsap.from(card, {
                    opacity: 0,
                    scale: 0.8,
                    duration: 0.6,
                    delay: i * 0.1,
                    scrollTrigger: {
                        trigger: '.fraet-community',
                        start: 'top 80%'
                    }
                });
            });
        }

        // ===========================================
        // TIMELINE - FLUJO CONTINUO
        // ===========================================
        
        const timelinePath = document.querySelector('.fraet-timeline-path');
        if (timelinePath) {
            gsap.fromTo(timelinePath,
                {
                    scaleY: 0,
                    transformOrigin: "top center"
                },
                {
                    scaleY: 1,
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.fraet-timeline',
                        start: "top 60%",
                        end: "bottom 30%",
                        scrub: 1
                    }
                }
            );
        }
        
        // Animar items del timeline con flow
        const timelineItems = gsap.utils.toArray('.fraet-timeline-item');
        
        timelineItems.forEach((item, i) => {
            const isOdd = i % 2 === 0;
            const dot = item.querySelector('.fraet-timeline-dot');
            
            // Estado inicial
            gsap.set(item, {
                opacity: 0,
                x: isOdd ? -50 : 50
            });
            
            // Timeline continuo
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: 'top 75%',
                    toggleActions: 'play pause resume reverse'
                }
            });
            
            // Animación fluida
            tl.to(item, {
                opacity: 1,
                x: 0,
                duration: 0.8,
                ease: "power2.out"
            });
            
            if (dot) {
                tl.from(dot, {
                    scale: 0,
                    duration: 0.4,
                    ease: "back.out(3)"
                }, "-=0.4");
            }
        });

        // ===========================================
        // CTA FINAL - BOTÓN QUE SE CONSTRUYE
        // ===========================================
        
        const ctaButton = document.querySelector('.fraet-cta-button');
        const ctaElements = [
            '.fraet-cta-tagline',
            '.fraet-cta-title',
            '.fraet-cta-text'
        ];
        
        // Primero animar los textos
        ScrollTrigger.create({
            trigger: '.fraet-cta',
            start: 'top 50%',
            onEnter: () => {
                gsap.from(ctaElements, {
                    y: 50,
                    opacity: 0,
                    duration: 1,
                    stagger: 0.2,
                    ease: "power3.out"
                });
            },
            once: true
        });
        
        // Efecto de construcción del botón con scroll
        if (ctaButton) {
            gsap.set(ctaButton, {
                opacity: 1,
                scale: 1
            });
            
            ScrollTrigger.create({
                trigger: '.fraet-cta',
                start: 'top 30%',
                end: 'top 10%',
                scrub: 1,
                onUpdate: self => {
                    const progress = self.progress;
                    
                    if (progress < 0.3) {
                        gsap.set(ctaButton, {
                            borderTopWidth: `${2 * (progress / 0.3)}px`,
                            borderLeftWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0
                        });
                    } else if (progress < 0.5) {
                        gsap.set(ctaButton, {
                            borderTopWidth: '2px',
                            borderRightWidth: `${2 * ((progress - 0.3) / 0.2)}px`,
                            borderLeftWidth: 0,
                            borderBottomWidth: 0
                        });
                    } else if (progress < 0.7) {
                        gsap.set(ctaButton, {
                            borderTopWidth: '2px',
                            borderRightWidth: '2px',
                            borderBottomWidth: `${2 * ((progress - 0.5) / 0.2)}px`,
                            borderLeftWidth: 0
                        });
                    } else if (progress < 0.9) {
                        gsap.set(ctaButton, {
                            borderTopWidth: '2px',
                            borderRightWidth: '2px',
                            borderBottomWidth: '2px',
                            borderLeftWidth: `${2 * ((progress - 0.7) / 0.2)}px`
                        });
                    } else {
                        ctaButton.classList.add('assembled');
                        gsap.set(ctaButton, {
                            borderWidth: '2px'
                        });
                    }
                }
            });
        }

        // ===========================================
        // EFECTOS DE CONTINUIDAD Y FLOW
        // ===========================================
        
        const sections = gsap.utils.toArray('.fraet-about > section');
        
        sections.forEach((section, i) => {
            gsap.from(section, {
                opacity: 0.3,
                duration: 1,
                scrollTrigger: {
                    trigger: section,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: 1
                }
            });
            
            if (i % 2 === 0) {
                gsap.to(section, {
                    yPercent: -5,
                    ease: "none",
                    scrollTrigger: {
                        trigger: section,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: 1
                    }
                });
            }
        });

        // ===========================================
        // COLOR TRANSITIONS
        // ===========================================
        
        const colorSections = [
            { trigger: '.fraet-hero', color: '#000000' },
            { trigger: '.fraet-manifesto', color: '#ffffff' },
            { trigger: '.fraet-design', color: '#000000' },
            { trigger: '.fraet-memories', color: '#f5f5f5' },
            { trigger: '.fraet-timeline', color: '#000000' },
            { trigger: '.fraet-cta', color: '#ffffff' }
        ];
        
        colorSections.forEach(section => {
            ScrollTrigger.create({
                trigger: section.trigger,
                start: 'top 50%',
                end: 'bottom 50%',
                onEnter: () => {
                    gsap.to('body', {
                        backgroundColor: section.color,
                        duration: 0.5,
                        ease: "power2.inOut"
                    });
                },
                onEnterBack: () => {
                    gsap.to('body', {
                        backgroundColor: section.color,
                        duration: 0.5,
                        ease: "power2.inOut"
                    });
                }
            });
        });

        // ===========================================
        // PERFORMANCE OPTIMIZATIONS
        // ===========================================
        
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                ScrollTrigger.refresh();
            }, 250);
        });
        
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                gsap.ticker.sleep();
            } else {
                gsap.ticker.wake();
            }
        });
        
        console.log('✨ Fraeternity Animations Initialized Successfully');
    }
});